import { handleActions } from 'redux-actions';
import { combineReducers } from 'redux';
import { getActionData, getActionDataSuccess, getActionDataFailure, getActionDataIdle } from '../actions';

const status_get_actionData = handleActions(
  {
    [getActionData.toString()]: (state, action) => 'LOADING',
    [getActionDataSuccess.toString()]: (state, action) => 'SUCCESS',
    [getActionDataFailure.toString()]: (state, action) => 'FAILURE',
    [getActionDataIdle.toString()]: (state, action) => 'IDLE',
  },
  'IDLE'
);

const data_get_actionData = handleActions(
  {
    [getActionData.toString()]: () => null,
    [getActionDataSuccess.toString()]: (state, action) => action.payload,
    
  },
  null
);

export { status_get_actionData, data_get_actionData };
